import React, { ReactNode } from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';

export const BaseCard = ({
  title,
  icon,
  children,
  headerAction,
  sx,
  canSplit = false,
}: {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  headerAction?: ReactNode;
  sx?: SxProps<Theme>;
  canSplit?: boolean;
}) => (
  <Box
    className={`base-card ${canSplit ? 'base-card-can-split' : 'avoid-break'}`}
    sx={{
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      border: '1px solid #ece7f2',
      borderLeftWidth: '5px',
      borderLeftColor: '#723989',
      boxShadow: '0 2px 12px rgba(114, 57, 137, 0.03)',
      mb: 3.5,
      display: 'flex',
      flexDirection: 'column',
      transition: 'box-shadow 0.25s ease, border-color 0.25s ease',
      '&:hover': {
        boxShadow: '0 6px 20px rgba(114, 57, 137, 0.07)',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    }}
  >
    <Box
      className="base-card-header"
      px={{ xs: 2.5, md: 3.5 }}
      py={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        borderBottom: '1px solid #f1ecf6',
        background: 'linear-gradient(to right, #faf8fc 0%, #ffffff 100%)',
        borderTopRightRadius: '16px',
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        {icon && (
          <Box
            sx={{
              bgcolor: '#f3eff7',
              color: '#68457c',
              width: 36,
              height: 36,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {React.isValidElement(icon)
              ? React.cloneElement(icon as React.ReactElement, { fontSize: 'small' })
              : icon}
          </Box>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e293b', letterSpacing: '0.04em' }}>
          {title.toUpperCase()}
        </Typography>
      </Box>
      {headerAction && <Box className="no-print">{headerAction}</Box>}
    </Box>
    <Box className="base-card-body" p={{ xs: 2.5, md: 3.5 }} flexGrow={1}>
      {children}
    </Box>
  </Box>
);
